import { Phone, Mail, MapPin, Clock, Send } from 'lucide-react'; 
import { useState } from 'react'; 
import emailjs from '@emailjs/browser'; 
export default function Contact() { 
  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    phone: '', 
    message: '' 
  }); 
  const [errors, setErrors] = useState({}); 
  const handleChange = (e) => { 
    const { name, value } = e.target; 
    setFormData((prev) => ({ 
      ...prev, 
      [name]: value 
    })); 
    
    if (errors[name]) { 
      setErrors((prev) => ({ 
        ...prev, 
        [name]: '' 
      })); 
    } 
  }; 
  
  const handleSubmit = async (e) => { 
    e.preventDefault(); 
    
    const newErrors = {}; 
    if (!formData.name.trim()) newErrors.name = 'Name is required'; 
    if (!formData.email.trim()) newErrors.email = 'Email is required'; 
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required'; 
    if (!formData.message.trim()) newErrors.message = 'Message is required'; 
    
    if (Object.keys(newErrors).length > 0) { 
      setErrors(newErrors); 
      return; 
    } 
    
    try { 
      await emailjs.send( 
        'service_ku17vdr', 
        'template_vhi0v8t', 
        { 
          from_name: formData.name, 
          from_email: formData.email, 
          phone: formData.phone, 
          message: formData.message 
        }, 
        'yv0Q1xCrTqhe6oFHj' 
      ); 
      
      alert('Thank you! Your message has been sent successfully.'); 
      
      setFormData({ 
        name: '', 
        email: '', 
        phone: '', 
        message: '' 
      }); 
    } catch (error) { 
      console.error('EmailJS Error:', error); 
      alert('Failed to send message. Please try again.'); 
    } 
  };

  return (
    <section id="contact" className="py-16 sm:py-24 bg-pink-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-display text-purple-dark mb-4">
            Get In <span className="text-purple-primary">Touch</span>
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
            We'd love to hear from you. Contact us for any queries or to schedule a visit
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          {/* Contact Information */}
          <div className="space-y-6 sm:space-y-8">
            {/* Contact Cards */}
            <div className="bg-gradient-to-br from-pink-light/30 to-purple-primary/20 rounded-2xl p-6 sm:p-8 shadow-soft">
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="bg-purple-primary text-white rounded-full w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center flex-shrink-0">
                  <Phone size={24} />
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-1 font-display">Phone</h4>
                  <a href="tel:+919267633372" className="text-gray-600 text-sm sm:text-base hover:text-purple-primary transition-colors font-medium">+91-9267633372</a>
                  <p className="text-gray-600 text-xs sm:text-sm mt-1">or</p>
                  <a href="tel:+918272876283" className="text-gray-600 text-sm sm:text-base hover:text-purple-primary transition-colors font-medium">+91-8272876283</a>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-pink-light/30 to-purple-primary/20 rounded-2xl p-6 sm:p-8 shadow-soft">
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="bg-purple-primary text-white rounded-full w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center flex-shrink-0">
                  <Mail size={24} />
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-1 font-display">Email</h4>
                  <a href="mailto:kinderheavenstudio@gmail.com" className="text-gray-600 text-sm sm:text-base hover:text-purple-primary transition-colors font-medium">kinderheavenstudio@gmail.com</a>
                  <p className="text-gray-600 text-xs sm:text-sm mt-1">Response within 24 hours</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-primary/10 to-pink-light/30 rounded-2xl p-6 sm:p-8 shadow-soft">
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="bg-purple-primary text-white rounded-full w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center flex-shrink-0">
                  <MapPin size={24} />
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-1 font-display">Address</h4>
                  <p className="text-gray-600 text-sm sm:text-base">Nal Road Opposite, R.S Resort</p>
                  <p className="text-gray-600 text-xs sm:text-sm mt-1">Amroha</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-pink-light/20 to-purple-primary/20 rounded-2xl p-6 sm:p-8 shadow-soft">
              <div className="flex items-start gap-4 sm:gap-6">
                <div className="bg-purple-primary text-white rounded-full w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center flex-shrink-0">
                  <Clock size={24} />
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-gray-800 mb-1 font-display">Hours</h4>
                  <p className="text-gray-600 text-sm sm:text-base">Mon - Fri: 7:30 AM - 5:30 PM</p>
                  <p className="text-gray-600 text-xs sm:text-sm">Sat: 8:00 AM - 1:00 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gradient-to-b from-pink-light/50 to-purple-primary/5 rounded-2xl p-6 sm:p-8 shadow-soft">
            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div>
                <label className="block text-gray-700 font-semibold text-sm sm:text-base mb-2">
                  Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg border-2 border-gray-300 focus:border-purple-primary focus:outline-none transition-colors text-sm sm:text-base"
                  placeholder="Your name"
                />
                {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
              </div>

              <div>
                <label className="block text-gray-700 font-semibold text-sm sm:text-base mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg border-2 border-gray-300 focus:border-purple-primary focus:outline-none transition-colors text-sm sm:text-base"
                  placeholder="your@email.com"
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
              </div>

              <div>
                <label className="block text-gray-700 font-semibold text-sm sm:text-base mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg border-2 border-gray-300 focus:border-purple-primary focus:outline-none transition-colors text-sm sm:text-base"
                  placeholder="+91-XXXXX-XXXXX"
                />
                {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
              </div>

              <div>
                <label className="block text-gray-700 font-semibold text-sm sm:text-base mb-2">
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="4"
                  className="w-full px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg border-2 border-gray-300 focus:border-purple-primary focus:outline-none transition-colors text-sm sm:text-base resize-none"
                  placeholder="Tell us about your inquiry..."
                />
                { errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
              </div>


              <button
                type="submit"
                className="w-full bg-purple-primary hover:bg-purple-dark text-white py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
              >
                <Send size={20} />
                Send Message
              </button>
            </form>
          </div>
        </div>

        {/* Google Maps */}
        <div className="mt-12 sm:mt-16 rounded-2xl overflow-hidden h-80 sm:h-96 shadow-soft">
          <iframe
            title="Kinder Heaven Location"
            width="100%"
            height="100%"
            frameBorder="0"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3477.4738159699707!2d78.64848!3d29.15849!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390b09005a0fae6f%3A0x3c0724e782bd5a29!2sKinder%20Heaven%2C%20Moti%20Nagar%20Colony%2C%20Amroha%2C%20Uttar%20Pradesh%20244221!5e0!3m2!1sen!2sin!4v1234567890"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
